import { IIconProps } from "../types"

export default function IconUL1(props: IIconProps) {
  const width = props.size || props.width || (93 / 5) * 3
  const height = props.size || props.height || (118 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 93 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.3792 0.545229C43.5901 0.765158 41.1309 1.265 38.3018 2.32466C35.4627 3.38432 32.2538 4.9938 29.2047 7.40303C26.1557 9.81226 23.2766 13.0312 19.8977 20.3889C16.5088 27.7565 12.6201 39.2628 9.78097 48.3099C6.95187 57.367 5.17245 63.9749 3.82288 70.2729C2.46331 76.5808 1.53361 82.5889 0.983788 87.7073C0.433964 92.8256 0.264019 97.0543 0.683884 100.693C1.11375 104.332 2.12342 107.381 3.22307 109.58C4.32272 111.78 5.51234 113.129 7.75162 114.149C10.0009 115.158 13.2998 115.838 19.008 116.308C24.7162 116.768 32.8436 117.028 42.1506 116.728C51.4576 116.428 61.9542 115.588 69.1819 114.659C76.4196 113.719 80.3983 112.709 83.2274 111.23C86.0665 109.75 87.756 107.801 89.1155 105.092C90.4651 102.383 91.4848 98.9137 91.9846 94.6451C92.4944 90.3664 92.4944 85.2881 91.8247 78.8201C91.1449 72.3422 89.7853 64.4747 87.756 55.4676C85.7266 46.4505 83.0175 36.3038 80.7782 29.236C78.5389 22.1683 76.7595 18.1896 74.5602 14.7207C72.3609 11.2518 69.7318 8.29274 66.4728 6.00348C63.2138 3.72421 59.3251 2.11473 55.8162 1.265C52.3073 0.425267 49.1683 0.335296 46.3792 0.545229Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
